/*
 * Toolbar will be used to build up and maintain a list of interactive/clickable elements.
 * 
 * constructor options:
 *      width: width of the toolbar
 *      container: element within which to add the toolbar items.
 */

(function () {
    "use strict";

    var LabelValueTable = Solovis.defineClass("Solovis.UI.Table.LabelValueTable",
        null,
        function (options) {
            this._options = options;

            this._container = options.container;

            this._width = options.width ? options.width : null;

            this._setupContainer();
        });

    LabelValueTable.prototype._setupContainer = function () {
        var self = this;

        this._table = $("<table>")
            .addClass("label-value-table-2")
            .css("width", "100%")
            .appendTo(this._container);

        this._table.tbody = $("<tbody>").appendTo(this._table);

        if (Solovis.isNotNull(this._width)) {
            this.width(this._width);
        }
    };

    LabelValueTable.prototype.width = function (newWidth) {
        if (arguments.length) {
            this._width = newWidth;

            if ($.isNumeric(this._width)) {
                this._container.width(this._width);
            }
            else if (this._width.indexOf("%") !== -1 ||
                this._width.indexOf("px") !== -1 ||
                this._width.indexOf("em") !== -1) {
                this._container.css("width", this._width);
            }
            return null;
        }
        else {
            return this._width;
        }
    };

    /*
     * options:
     * 
     *  label: the label for the row
     *  value: the text value for the row
     *  element: jquery element to place in the value cell of the row.  Overrides text.
     *  html: html to write into the value cell of the row.  Overrides text and element.
     *  help: (standard help declaration object)
     */

    LabelValueTable.prototype.addRow = function (options) {
        var self = this;

        var label = options.label;
        var html = options.html ? options.html : null;
        var value = options.value ? options.value : null;;
        var help = options.help ? options.help : null;
        var element = options.element ? options.element : null;

        var row = $("<tr>").appendTo(this._table.tbody);

        var labelCell = $("<td>")
            .appendTo(row);

        $("<span>")
            .text(label)
            .addClass("row-label")
            .appendTo(labelCell);

        var valueCell = $("<td>")
            .appendTo(row);

        if (html) {
            valueCell.html(html);
        }
        else if (element) {
            valueCell.append(element);
        }
        else {
            valueCell.text(value);
        }

        if (help) {
            var helpLink = $("<a>")
                .css("padding", "0 5px")
                .click(function () {
                    Solovis.Site.HelpManager.showCustomHelpDialog(
                        help,
                        {
                            title: self._label
                        });
                })
                .appendTo(labelCell);

            $("<span>")
                .addClass("fa fa-question-circle")
                .appendTo(helpLink);

        }
    };

    LabelValueTable.prototype.getTable = function () {
        return this._table;
    };

})();